import STable from "@/components/Table";
import Ellipsis from "@/components/Ellipsis";
import Authorized from "@/components/Authorized";

export { STable, Ellipsis, Authorized };
